// extracted by mini-css-extract-plugin
export default {"customTableCell":"CustomTableCell_customTableCell__JXS-x","textWrapper":"CustomTableCell_textWrapper__0yF9h"};